import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { AbstractVerifyPhotoDirective } from '@directives/abstract-verify-photo.directive';
import { Photo } from '@models/photo';
import { isOnMobile } from '@services/browser';
import { TranslateModule } from '@ngx-translate/core';
import { PhotoHelpComponent } from '../photo-help/photo-help.component';
import { CloseOverlayKeyboardDirective } from '../../directives/close-overlay.directives';
import { CommonModule } from '@angular/common';
import { CameraFeedComponent } from '../camera-feed/camera-feed.component';
import { IconDirective } from '../../directives/icon.directive';
import { ConfirmValidIdComponent } from '../confirm-valid-id/confirm-valid-id.component';

@Component({
  selector: 'lv-verify-id',
  styleUrls: ['verify-id.component.scss'],
  templateUrl: 'verify-id.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    TranslateModule,
    PhotoHelpComponent,
    CloseOverlayKeyboardDirective,
    CameraFeedComponent,
    IconDirective,
    ConfirmValidIdComponent
  ]
})
export class VerifyIdComponent extends AbstractVerifyPhotoDirective implements OnInit, OnDestroy {
  @Input() sessionToken: string;

  get isOnDesktop(): boolean {
    return !isOnMobile();
  }

  ngOnInit() {
    this.photoConfirmed = false;

    this.identificationChannel = this.subscribeToIdentificationChannel(this.sessionToken);

    this.photo$.subscribe((photo) => {
      if (photo) {
        this.identificationChannel.perform('validates_id', { photo: photo.payload });
      }
    });

    super.ngOnInit();
  }

  ngOnDestroy() {
    this.unsubscribeFromIdentificationChannel();

    this.photo$.unsubscribe();
  }

  capture(photo: Photo) {
    this.photoVerificationResponse$.next(null);
    this.photoVerificationLoading.set(true);
    this.showTryAgainButton = true; // Reset button visibility for new photo

    super.capture(photo);
  }

  handlePhoto(photo: Photo) {
    this.photo$.next(photo);
    this.channel.perform('rebroadcast', { freshIdPhoto: photo.payload });
  }

  onPhotoConfirmed(confirmed: boolean) {
    this.photoConfirmed = confirmed;
  }
}
